import { useSubmit } from "@hyper-fetch/react";
import { Download } from "lucide-react";
import { toast } from "sonner";

import { sdk } from "@/api/sdk";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { m } from "@/paraglide/messages.js";

const downloadRequest = sdk.me.payments.orders.$orderId.download.$get;

/** Downloads a digital product the person paid for. The link is fresh on every tap: it lives minutes. */
export function DownloadButton({
  orderId,
  size = "sm",
  onOpen = (url) => window.location.assign(url),
}: {
  orderId: string;
  size?: "sm" | "default";
  onOpen?: (url: string) => void;
}) {
  const download = useSubmit(downloadRequest);

  const start = async () => {
    const { data, error } = await download.submit({ params: { orderId } });
    if (error || !data) {
      toast.error(error?.message || m.shop_download_failed());
      return;
    }
    onOpen(data.url);
  };

  return (
    <Button type="button" size={size} onClick={() => void start()} disabled={download.submitting}>
      {download.submitting ? <Spinner /> : <Download aria-hidden />}
      {m.shop_download()}
    </Button>
  );
}
